export interface Contact {
	tel: string;
	email: string;
}
